// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jaa1","colMin":"styles_colMin__3Pc4p"};